import { FC } from "react";
import { Box, Stack, StackProps } from "@chakra-ui/react";
import { getStarDecomposition } from "./utils";
import { ShiIcon } from "src/atoms";

const RatingsGradeStar: FC<Partial<any>> = (props) => (
  <ShiIcon name="star" position="absolute" top={0} left={0} {...props} />
);

type RatingsGradeStarsProps =
  StackProps
  & {
    value: number;
    size?: string | number;
    spacing?: StackProps["spacing"];
    fill?: string;
    fillPlaceholder?: string;
  };

const RatingsGradeStars: FC<RatingsGradeStarsProps> = ({
  value,
  size = "1em",
  spacing = "space-4",
  fill = "grey-1",
  fillPlaceholder = "greyLight-6",
  ...props
}) => {
  const { STAR_NUMBER, fullStarsCount, lastStarPolygon } = getStarDecomposition(
    value,
  );

  return (
    <Stack spacing={spacing} direction="row" {...props}>
      {Array(STAR_NUMBER)
        .fill("")
        .map((_, i) => (
          <Box key={i} position="relative" boxSize={size}>
            {i >= fullStarsCount && (
              <RatingsGradeStar
                sx={{
                  path: {
                    fill: fillPlaceholder,
                  },
                }}
                width={size}
                w="auto"
                h="auto"
              />
            )}

            {i <= fullStarsCount && (
              <RatingsGradeStar
                sx={{
                  path: {
                    fill,
                  },
                }}
                css={
                  i === fullStarsCount && {
                    clipPath: lastStarPolygon,
                  }
                }
                width={size}
                w="auto"
                h="auto"
              />
            )}
          </Box>
        ))}
    </Stack>
  );
};

export default RatingsGradeStars;
